import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
/**
* This file was automatically generated by @cosmwasm/ts-codegen@0.21.1.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/

export class JunoSwapQueryClient {
  constructor(client, contractAddress) {
    _defineProperty(this, "client", void 0);
    _defineProperty(this, "contractAddress", void 0);
    _defineProperty(this, "balance", async ({
      address
    }) => {
      return this.client.queryContractSmart(this.contractAddress, {
        balance: {
          address
        }
      });
    });
    _defineProperty(this, "info", async () => {
      return this.client.queryContractSmart(this.contractAddress, {
        info: {}
      });
    });
    _defineProperty(this, "token1ForToken2Price", async ({
      token1Amount
    }) => {
      return this.client.queryContractSmart(this.contractAddress, {
        token1_for_token2_price: {
          token1_amount: token1Amount
        }
      });
    });
    _defineProperty(this, "token2ForToken1Price", async ({
      token2Amount
    }) => {
      return this.client.queryContractSmart(this.contractAddress, {
        token2_for_token1_price: {
          token2_amount: token2Amount
        }
      });
    });
    this.client = client;
    this.contractAddress = contractAddress;
    this.balance = this.balance.bind(this);
    this.info = this.info.bind(this);
    this.token1ForToken2Price = this.token1ForToken2Price.bind(this);
    this.token2ForToken1Price = this.token2ForToken1Price.bind(this);
  }
}
export class JunoSwapClient extends JunoSwapQueryClient {
  constructor(client, sender, contractAddress) {
    super(client, contractAddress);
    _defineProperty(this, "client", void 0);
    _defineProperty(this, "sender", void 0);
    _defineProperty(this, "contractAddress", void 0);
    _defineProperty(this, "addLiquidity", async ({
      expiration,
      maxToken2,
      minLiquidity,
      token1Amount
    }, fee = "auto", memo, funds) => {
      return await this.client.execute(this.sender, this.contractAddress, {
        add_liquidity: {
          expiration,
          max_token2: maxToken2,
          min_liquidity: minLiquidity,
          token1_amount: token1Amount
        }
      }, fee, memo, funds);
    });
    _defineProperty(this, "removeLiquidity", async ({
      amount,
      expiration,
      minToken1,
      minToken2
    }, fee = "auto", memo, funds) => {
      return await this.client.execute(this.sender, this.contractAddress, {
        remove_liquidity: {
          amount,
          expiration,
          min_token1: minToken1,
          min_token2: minToken2
        }
      }, fee, memo, funds);
    });
    _defineProperty(this, "swap", async ({
      expiration,
      inputAmount,
      inputToken,
      minOutput
    }, fee = "auto", memo, funds) => {
      return await this.client.execute(this.sender, this.contractAddress, {
        swap: {
          expiration,
          input_amount: inputAmount,
          input_token: inputToken,
          min_output: minOutput
        }
      }, fee, memo, funds);
    });
    _defineProperty(this, "passThroughSwap", async ({
      expiration,
      inputToken,
      inputTokenAmount,
      outputAmmAddress,
      outputMinToken
    }, fee = "auto", memo, funds) => {
      return await this.client.execute(this.sender, this.contractAddress, {
        pass_through_swap: {
          expiration,
          input_token: inputToken,
          input_token_amount: inputTokenAmount,
          output_amm_address: outputAmmAddress,
          output_min_token: outputMinToken
        }
      }, fee, memo, funds);
    });
    _defineProperty(this, "swapAndSendTo", async ({
      expiration,
      inputAmount,
      inputToken,
      minToken,
      recipient
    }, fee = "auto", memo, funds) => {
      return await this.client.execute(this.sender, this.contractAddress, {
        swap_and_send_to: {
          expiration,
          input_amount: inputAmount,
          input_token: inputToken,
          min_token: minToken,
          recipient
        }
      }, fee, memo, funds);
    });
    _defineProperty(this, "updateConfig", async ({
      lpFeePercent,
      owner,
      protocolFeePercent,
      protocolFeeRecipient
    }, fee = "auto", memo, funds) => {
      return await this.client.execute(this.sender, this.contractAddress, {
        update_config: {
          lp_fee_percent: lpFeePercent,
          owner,
          protocol_fee_percent: protocolFeePercent,
          protocol_fee_recipient: protocolFeeRecipient
        }
      }, fee, memo, funds);
    });
    this.client = client;
    this.sender = sender;
    this.contractAddress = contractAddress;
    this.addLiquidity = this.addLiquidity.bind(this);
    this.removeLiquidity = this.removeLiquidity.bind(this);
    this.swap = this.swap.bind(this);
    this.passThroughSwap = this.passThroughSwap.bind(this);
    this.swapAndSendTo = this.swapAndSendTo.bind(this);
    this.updateConfig = this.updateConfig.bind(this);
  }
}